import { getVersionFromVersion } from "../versions/getVersion";
export * from "./signatures";
export function getCalldataForActuator(data) {
    const Version = getVersionFromVersion(data.version);
    return Version.Utils.getCalldataForActuatorWithSignedFCT(data);
}
//# sourceMappingURL=index.js.map